// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"EmailDeal-mobile__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/EmailDeal/EmailDeal.mobile.scss
 ** module id = 914
 ** module chunks = 1
 **/